/* ---------------------------- DATE VALIDATION STUFF ----------------------- */
function dateSetup(){
	$$('.format_date').each(function(ob){
		var dates = formatDate($F(ob));
		if($(ob.id+'_parsed')) $(ob.id+'_parsed').innerHTML = dates[0];
		if($(ob.id+'_sql')) 	$(ob.id+'_sql').value 		= dates[1]||null;
		if($(ob.id+'_has_time')) $(ob.id+'_has_time').value = dates[2]?1:0;
	});
}
function clock_calc_time(e){
	e = e.element?e.element():$(e);
	var selects = e.up('tr').select('select');
	var date = [new Date(), new Date()];
	date[0].setHours(Number($F(selects[1]))+Number($F(selects[3])));
	date[0].setMinutes(Number($F(selects[2])));
	date[1].setHours(Number($F(selects[5]))+Number($F(selects[7]))
	//TODO: allow turn-of-the-month spanning
		+(Number($F(selects[4]).replace(/\-/g,''))-Number($F(selects[0]).replace(/\-/g,''))) // days
		*24
	);
	date[1].setMinutes(Number($F(selects[6])));
	date = (date[1] - date[0])/60000;
	if(date <= 0)
		e.up('tr').down('.calc_clock').update('-');
	else {
		var hr = Math.floor(date/60), min = Math.round(date % 60)
		e.up('tr').down('.calc_clock').update(hr + 'h ' + min + 'm');
	}
}

function clock_calc_time_2(elem,startinput, endinput){
	elem = $(elem);
	var a     = $F(startinput).split(/[^0-9]/);
	var start = new Date ( a[0],a[1]-1,a[2],a[3],a[4],a[5]?a[5]:0 );
	a     = $F(endinput).split(/[^0-9]/);
	var end   = new Date ( a[0],a[1]-1,a[2],a[3],a[4],a[5]?a[5]:0 );
	var date = (end - start) / 60000;
	if (isNaN(date) || date <= 0){
		elem.up('tr').down('.calc_clock').update('-');
		am.$('#newtimecardsavebutton').addClass('am-btn--disabled');
		show_snackbar({
			message: 'please select a valid date and time',
			type: 'warning',
			timer: 1000,
			show_close: false
		});
	}
	else {
		var hr = Math.floor(date / 60), min = Math.round(date % 60)
		elem.up('tr').down('.calc_clock').update(hr + 'h ' + min + 'm');
		am.$('#newtimecardsavebutton').removeClass('am-btn--disabled');
	}
}

function ticking_clock(ticker, del){
	setTimeout(function(){ ticking_clock(ticker, del); }, del);
	ticker = $(ticker);
	if(!ticker) return;
	var time = (Number(ticker.value) + del) / 60000;
	var hr = Math.floor(time/60);
	var min = Math.floor(time%60);
	ticker.value = time * 60000;
	ticker.update(hr + 'h ' + min + 'm');
	if(cur = $('work_hours_bar').down('.cur'))
		cur.setStyle({'width' : Math.ceil(time/12)});
}

function text2num(str){
	var i = -1;
	while(text2num.regex[++i]){
		str = str.replace(text2num.regex[i][0], text2num.regex[i][1]);
	}
	return str;
}
text2num.regex = [
	[/([^ ]+) ?thousand/ig, '$1'+'000'],
	[/([^ ]+) ?hundred/ig, '$1'+'00'],
	[/ninet[yi]/ig, '90 '],
	[/(eight[yi])/ig, '80 '],
	[/sevent[yi]/ig, '70 '],
	[/sixt[yi]/ig, '60 '],
	[/fift[yi]/ig, '50 '],
	[/fourt[yi]/ig, '40 '],
	[/thirt[yi]/ig, '30 '],
	[/twent[yi]/ig, '20 '],
	[/([a-z]+)teen/ig, '1$1'],
	[/twelve/ig, '12 '],
	[/eleven/ig, '11 '],
	[/ten/ig, '10 '],
	[/nine/ig, '9'],
	[/eight/ig, '8'],
	[/seven/ig, '7'],
	[/six/ig, '6'],
	[/(five|fif)/ig, '5'],
	[/four/ig, '4'],
	[/three/ig, '3'],
	[/third/ig, '3rd'],
	[/(two|seco)/ig, '2'],
	[/(one|fir)/ig, '1'],
	[/\bat\b/i, '@'],
	[/(\d+)\D*000\D+(\d{3})\D/g, '$1$2 '], //combines thousands and hundreds
	[/(\d+)[^\d\:]*00[^\d\:]+(\d{2})[^\d\:]/g, '$1$2 '],	// This could probably be a for-next loop
	[/(\d+)\D*0\D+(\d)\s/g, '$1$2 '], //combines tens and ones
	[/o\'?clock/i, ':00']	//'
];
function formatDate(str){
	if(!str || str.blank()) return ['','',false];
	str = text2num(str.toLowerCase().replace(',',' ').replace(/^\s+/,'').replace(/\s+$/,''));
	var year,mon,mm,day,dd,hr,hr12,hr24,min,sec,ap,ht = false;
	// types of figures:  integer, occurrence (1st, 2nd, 3rd, 4th), unit, name, keyword
	var raw_units = str.split(/\s+/);
	// var clean = text2num(str);
    var months = [
        get_language_translation('LANG_MONTHS_JANUARY_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_FEBRUARY_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_MARCH_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_APRIL_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_MAY_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_JUNE_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_JULY_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_AUGUST_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_SEPTEMBER_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_OCTOBER_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_NOVEMBER_LONG').toLowerCase(),
        get_language_translation('LANG_MONTHS_DECEMBER_LONG').toLowerCase()
    ];
	var days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
	// var times = ['at','am','pm','noon','night'];
	var units = ['seconds','minutes','hours','days','weeks','months','quarters','years','century','centuries'];
	var keywords = ['yesterday','today','tomorrow','now','last','ago','previous','this','next','in','forever','never','ever','before','after','from'];
	//abr_names = [];

	// var names = months.concat(days);
	//names.each(function(o){ abr_names.push(o.slice(0,3)); });

	mon = find_any_in_array(raw_units, months);
	if(mon) date = new Date();
	var raw_numbers = [];
	
	var v, t, s, i;
	while(v = raw_units.shift()){
		if(v.blank()) continue;
		if((t = find_aprox_in_array(keywords,v))!==false){
			var date = false, dir = 1;
			switch(keywords[t]){	//TODO: optimize by looking for the index instead of the string
				case 'last': case 'previous':
					dir = -1
					date = new Date();
					date.setDate(date.getDate()-7);
					break;
				case 'this':
					if(!date) date = new Date();
					break;
				case 'next':
					if(raw_units.length == 0) break;	//TODO: check for backwards usage, like "friday next"
					attempt = raw_units[0].match(/^mont/);
					if(attempt){
						date = new Date();
						date.setMonth(date.getMonth() + dir);
						raw_units.shift();
					} else if(ind = find_aprox_in_array(days,raw_units[0])){					// [keyword] [dayOfWeek]
						if(!date){
							date = new Date();
							date.setDate(date.getDate()+7);
						}
						while(date.getDay())
							date.setDate(date.getDate()-1);
						do{
							date.setDate(date.getDate()+1);
						} while (ind != date.getDay());
						raw_units.shift();
					} else if((ind = find_aprox_in_array(months,raw_units[0]))!==false){		// [keyword] [month] [optional_day]
						date = new Date();
						do{
							date.setMonth(date.getMonth()+dir);
						} while (ind != date.getMonth());
						if(raw_units.length > 1 && Number(raw_units[1])){
							date.setDate(Number(raw_units[1]));
							raw_units.shift();
						} else date.setDate(1);
						raw_units.shift();
					} else if((ind = find_aprox_in_array(units,raw_units[0]))!==false){		// [keyword] [unit]
						switch(units[ind]){
							case 'days':
								date = new Date();
								date.setDate(date.getDate() + dir);
								raw_units.shift();
								break;
							case 'weeks':
								date = new Date();
								date.setDate(date.getDate() + dir*7);
								raw_units.shift();
								break;
							case 'months':
								date = new Date();
								date.setMonth(date.getMonth() + dir);
								raw_units.shift();
								break;
							case 'quarters':
								date = new Date();
								date.setMonth(date.getMonth() + dir*4);
								raw_units.shift();
								break;
							case 'years':
								date = new Date();
								date.setFullYear(date.getFullYear() + dir);
								raw_units.shift();
								break;
						}
					} else if(parseInt(raw_units[0]) && raw_units.length > 1){
						if((ind = find_aprox_in_array(months, raw_units[0]))!== false){		// [keyword] [day] [month]
							date = new Date();
							var dest_month = (dir*ind)-date.getMonth();
							while(dest_month*dir<0){ dest_month+=(dir*12); } 
							date.setMonth(date.getMonth()+dest_month);
							date.setDate(raw_units[0]);
							raw_units.shift();
							raw_units.shift();
						}
					}
					break;
				case 'in':
					if(raw_units.length < 2 || !Number(raw_units[0])) break;
					var num = Number(raw_units[0]);
					attempt = raw_units[1].match(/^mond/);
					if(attempt){
						date = new Date();
						// move to the next occurance of that day of the week
						date.setDate(date.getDate()+(2-date.getDay()));
						// move [num] weeks
						date.setDate(date.getDate() + 7*num);
						raw_units.shift();
						raw_units.shift();
					} else if((ind = find_aprox_in_array(units, raw_units[1]))!==false){				// in [quantity] [units]
						switch(units[ind]){
							case 'days':
								date = new Date();
								date.setDate(date.getDate() + num);
								raw_units.shift();
								break;
							case 'weeks':
								date = new Date();
								date.setDate(date.getDate() + 7*num);
								raw_units.shift();
								break;
							case 'months':
								date = new Date();
								date.setMonth(date.getMonth() + num);
								raw_units.shift();
								break;
							case 'quarters':
								date = new Date();
								date.setMonth(date.getMonth() + 4*num);
								raw_units.shift();
								break;
							case 'years':
								date = new Date();
								date.setFullYear(date.getFullYear() + num);
								raw_units.shift();
								break;
						}
						raw_units.shift();
					} else if((ind = find_aprox_in_array(days, raw_units[1]))!==false){		// in [quantity] [dayOfWeek]
						date = new Date();
						// move to the next occurance of that day of the week
						date.setDate(date.getDate()+((ind+1)-date.getDay()));
						// move [num] weeks
						date.setDate(date.getDate() + 7*num);
						raw_units.shift();
						raw_units.shift();
					} else if((ind = find_aprox_in_array(months, raw_units[1]))!==false){		// in [quantity] [monthName] [optioanl_day]
						date = new Date();
						var dest_month = (ind)-date.getMonth();
						while(dest_month*dir<0){ dest_month+=(12); } 
						date.setMonth(date.getMonth()+dest_month);
						date.setFullYear(date.getFullYear()+num);
						if(raw_units.length > 2 && Number(raw_units[2])){
							date.setDate(Number(raw_units[2]));
							raw_units.shift();
						} else date.setDate(1);
						raw_units.shift();
						raw_units.shift();
					}
					break;
				case 'now':
					date = new Date();
					ht = true;		// intentionally no break; here
				case 'today':
					date = new Date();
					break;
				case 'yesterday':
					date = new Date();
					date.setDate(date.getDate()-1);
					break;
				case 'tomorrow':
					date = new Date();
					date.setDate(date.getDate()+1);
					break;
				case 'forever': case 'never': case 'ever':
					date = 'This task will repeat indefinitely';
					break;
				// 'from', 'ago', 'before' and 'after' are to added
			}
			if(date && typeof(date)=='object'){
				year = date.getFullYear();
				mm = date.getMonth()+1;
				mon = months[date.getMonth()];
				dd = date.getDate();
				if(ht){
					hr = date.getHours();
					min = date.getMinutes();
					sec = date.getSeconds();
				}
			}
		} else if((ind = find_aprox_in_array(days,v))!==false){
			date = new Date();
			while (ind != date.getDay()){
				date.setDate(date.getDate()+1);
			}
			year = date.getFullYear();
			mm = date.getMonth()+1;
			mon = months[date.getMonth()];
			dd = date.getDate();
			if(ht){
				hr = date.getHours();
				min = date.getMinutes();
				sec = date.getSeconds();
			}
		} else if(!mon && !mm){
			var attempt = v.match(/^\d+\-\d+\-\d+$/);
			if(attempt){
				// probably YYYY-MM-DD
				date = true;
				var arr = v.split('-');
				year = arr.shift();
				mm = arr.shift();
				dd = arr.shift();
				continue;
			}
			attempt = v.match(/^\d+\.\d+\.\d+$/);
			if(attempt){
				// probably dd.mm.yyyy
				date = true;
				arr = v.split('.');
				dd = arr.shift();
				mm = arr.shift();
				year = arr.shift();
				continue;
			}
			attempt = v.match(/^\d+\/\d+\/\d+$/);
			if(attempt){
				// probably mm/dd/yyyy
				date = true;
				arr = v.split('/');
				mm = arr.shift();
				dd = arr.shift();
				year = arr.shift();
				continue;
			}
		} else if(!hr24 && !hr12 && !hr){
			attempt = v.match(/^\d+\:\d+/);
			if(attempt){
				ht = true;
				arr = v.split(':');
				hr = arr.shift();
				min = arr.shift(); if(min) min = parseInt(min,10);
				sec = arr.shift(); if(sec) sec = parseInt(sec,10);
				if(v.match('a') || (raw_units[i+1] && raw_units[i+1][0]=='a')){
					ap = 'a';
					hr12 = hr;
				} else if(v.match('p') || (raw_units[i+1] && raw_units[i+1][0]=='p')){
					ap = 'p';
					hr12 = hr;
				}
				continue;
			}
		} else if(!ap){
			if(v.match('p')){
				ap = 'p';
			}else if(v.match('a')){
				ap = 'a';
			}
		}
		t = v.match(/\d+/g);
		if(t) raw_numbers = raw_numbers.concat(t);
	}
	if(raw_numbers){
		while(s = raw_numbers.shift()){
			var v = Number(s);
			switch(s.length){
				case 4:
					if(!year && v>1990 && v<2130){	// if it lies within a reasonable range of years
						year = v;
					} else if(v >= 0 && v <= 2359 && Number(s.slice(-2,999)) < 60 && !hr24 && !hr12 && !min){
						hr24 = Number(s.slice(0,2));
						min = s.slice(-2,999);
						ht = true;
					} else {
						year = v;
					}
					break;
				case 3:
				case 2:
				case 1:
					if(v >= 1 && v <= 12 && !mon && !mm){
						mm = v>9?v:'0'+v;
					} else if(v >= 1 && v <= 31 && !day && !dd){
						day = v;
					} else if(!year){
						year = v;
					} else if(v >= 1 && v <= 12 && !hr12 && !hr24 && !hr){
						hr12 = v; ht = true;
					} else if(v >= 0 && v <= 23 && !hr12 && !hr24 && !hr){
						hr24 = v; ht = true;
					} else if(v >= 0 && v <= 59 && !min){
						min = v; ht = true;
					} else if(v >= 0 && v <= 59 && !sec){
						sec = v; ht = true;
					}
					break;
			}
		}
	}
	if(year){
		if(Number(year) < 500) year = Number(year) + 2000;
	} else {
		if(date && typeof(date)=='object') year = date.getFullYear();
	}
	if(!mon && !mm && date && typeof(date)=='object'){
		mon = months[date.getMonth()];
		mm = date.getMonth()+1;
	} else if(mon && !mm){
		mm = find_aprox_in_array(months,mon) + 1;
	} else if(!mon && mm){
		mon = months[Number(mm)-1];
	}
	mm = mm>9?Number(mm):'0'+Number(mm);
	if(mon) mon = mon.slice(0,3).capitalize();
	if(day && !dd){
		day = Number(day);
		dd = day>9?day:'0'+day;
	} else if(!day && dd){
		day = Number(dd);
		dd = day>9?day:'0'+day;
	} else if(!day && !dd && date && typeof(date)=='object'){
		day = 1;
		dd = '01';
	}
	if(ht){
		if(hr && !hr24 && !hr12){
			if(ap=='a'){
				if (hr == 12)
					hr24 = 0;
				else
					hr24 = hr;
			} else if(ap == 'p'){
				hr24 = (hr%12) + 12;
			} else if(hr==0 || hr > 12){
				hr24 = hr;
			} else {
				hr12 = hr;				
			}
		}
		if(hr24 !== false && !hr12){
			hr12 = hr24==0?12:(hr24>12?hr24-12:hr24);
		} else if(hr12 && !hr24){
			if(ap){
				hr24 = (hr12 % 12) + ('p'==ap?12:0);
			} else {
				hr24 = hr12;
			}
		}
		min = min?(min>9?Number(min):'0'+Number(min)):'00';
		if(sec) sec = sec>9?Number(sec):'0'+Number(sec);
		if(!ap){
			var end = str.match(/[ap][^ap]*$/);
			end = end?end.pop():false;
			if(end){
				ap = end.match(/[ap]/);
				ap = ap?ap.pop():false;
			}
			if(!ap){
				ap = hr24==0?'a':(hr24>=12?'p':'a');
			}
		}
	}
	if(ap == 'p' && hr24 < 12) hr24+=12;
	return [(
		date?(typeof(date)=='string'?date:(mon + " " + day + ", " + year +
		(ht?' '+hr12+':'+min+(sec?':'+sec:'')+' '+ap.toUpperCase()+'M':''))):'?'
	),(
		typeof(date)=='object'||date==true?(year+'-'+mm+'-'+(day<10?'0':'')+day+
		(ht?' '+hr24+':'+min+(sec?':'+sec:''):'')):null
	), ht];
}
function find_any_in_array(haystack, needle){
	var close = false;
	for(var i = 0; i < needle.length; i++){
		var t = find_aprox_in_array(haystack,needle[i]);
		if(t) return needle[i];
		close = close || (find_aprox_in_array(haystack,needle[i])!==false?needle[i]:false);
	}
	return close;
}
function find_aprox_in_array(haystack, needle){
	var close = false, stub = needle.slice(0,3);
	for(var i = 0; i < haystack.length; i++){
		if(haystack[i] == needle) return i;
		close = close || ((haystack[i].slice(0,3) == stub)?i+1:false);
	}
	return close===false?false:close-1;
}
function find_in_array(haystack, needle){
	for(var i = 0; i < haystack.length; i++){
		if(haystack[i] == needle) return i;
	}
	return -1;
}

function daysTil(date,day_of_week){
	var cur = date.getDay();
	cur = Math.abs(day_of_week) - 1 - cur;
	if(cur <= 0 && day_of_week > 0) cur += 7;
	return cur;
}
function stringMonth(o){
	switch(Number(o)){
		case 1: return "Jan";
		case 2: return "Feb";
		case 3: return "Mar";
		case 4: return "Apr";
		case 5: return "May";
		case 6: return "June";
		case 7: return "Jul";
		case 8: return "Aug";
		case 9: return "Sep";
		case 10: return "Oct";
		case 11: return "Nov";
		case 12: return "Dec";
	}
}
function daysInMonth(mon, year){
	year = year || 1;
	if(!mon.match(/\D/))	// if it's all digits
		mon = stringMonth(mon);
	mon = mon.toLowerCase();
	switch(mon[0]){
		case "j":
			if(mon[1] == 'a' || mon[2] == 'l'){
				return 31;
			} else {
				return 30;
			}
		case "f": return year%4&&!year%100||year%400?28:29;
		case "a":
			if(mon[1] == 'p'){
				return 30;
			} else {
				return 31;
			}
		case "n": return 30;
		case "m": case "s": case "o": case "d": return 31;
	}
}
function repeat_form(o){	// handles the form elements for repeating tasks
	var val = $F(o);
	var inner = o.childElements()[o.selectedIndex].innerHTML.replace(/\s+/g,'').underscore();
	var div = $('end_date_div');
	var typ = 'hidden';
	if(div) {
		if('once' == val){
			div.hide();
		} else {
			div.show();
		}
	}
	if('...'== inner.substring(inner.length-3,inner.length)){
		typ = 'checkbox';
	}

	div = $(o.getAttribute('rel'));
	if(div){
		var date = $('start_date_parsed').innerHTML=='?'?new Date():new Date(Date.parse($('start_date_parsed').innerHTML));
		$(o.getAttribute('rel')).update('');
		var ul = new Element('ul').setStyle({'margin':'0'});
		var list, i, which=[];
		if('days'==val){
			list = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
			if('weekly' == inner){
				which = [false,false,false,false,false,false,false];
				which[date.getDay()] = true;
			} else {
				which = [true,true,true,true,true,true,true];
			}
			i = 0;
		} else if('months'==val){
			list = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
			if('annually' == inner){
				which = [null,false,false,false,false,false,false,false,false,false,false,false,false];
				which[date.getMonth()+1] = true;
			} else {
				which = [null,true,true,true,true,true,true,true,true,true,true,true,true];
			}
			i = 1;
		}
		if(list){
			list.each(function(li){
				if('checkbox' == typ){
					ul.insert(new Element('li').update(li+"<br/><input name='rep_dat["+i+"]' value='"+i+"' type='"+typ+"'"+(which[i]?" checked":'')+"/>"));
				} else if('hidden' == typ && which[i]){
					ul.insert("<input name='rep_dat["+i+"]' value='"+i+"' type='hidden'/>");
				}
				i++;
			});
			div.update(ul);
			div.insert( new Element('br', {'class':'clear'}) )
			div.show();
		}
	}
	document.fire('date:fire');		// force date formatting to update
}
function valid_date(id,after){
	var o = $(id+'_parsed');
	if(o.innerHTML=='?' || o.innerHTML.blank()){
		if(!$('advice-required-'+id))
			o.insert({after: new Element('div',{'id':'advice-required-'+id,'class':'validation-advice'}).update('Invalid date/time.') });
		return true;
	} else {
		var date = new Date(Date.parse(o.innerHTML));
		
		// Dates without times default to the previous midnight until they get into the database.
		// Thus, allow for tasks due during the previous 24 hours (which includes that midnight).
		date.setDate(date.getDate()+1);
		if(after > date){
			if($('advice-required-'+id))
				$('advice-required-'+id).update('Time travel error:  too soon.');
			else
				o.insert({after: new Element('div',{'id':'advice-required-'+id,'class':'validation-advice'}).update('Time travel error: too soon.') });
			return true;
		} else {
			if($('advice-required-'+id))
				$('advice-required-'+id).remove();
			return false;
		}
	}
}